/* eslint-disable */
import _ from "lodash/fp";
import { useEffect, useState } from "react";
import { Modal } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { emailRegex } from "../../../common/constants/regex";
import docLabels from '../../documentsverification/labels/documentlabel.json';
import "../../styles/admin_user_nav.css";
import { editAllApprovalUser, getAllRoles, getSupervisorByDeptAndRoleId } from "../actions/userAction";
import userLabels from '../labels/users_en.json';

const defaultUser = {
  email: "",
  mobile: "",
  roleId: "",
  isActive: true,
  lastName: "",
  password: "",
  roleName: "",
  username: "",
  firstName: "",
  departmentId: 1,
  departmentName: "",
  supervisorName: ""
};

const UpdateApprovalUser = (props) => {
    const { register, handleSubmit, errors, watch } = useForm({ mode: "onChange" });
    const dispatch = useDispatch();
    const [departmentList, setDeparmentList] = useState("")
    const [roleList, setRoleList] = useState("")
    const [supervisorList, setSupervisorList] = useState("")
const [user, setUser] = useState(defaultUser);


    const { adminDepartments } = useSelector((state) => state.common, shallowEqual);
    let { roleByDept, supervisorByRole ,singleApprovalDetails} = useSelector((state) => state.userManagementReducer, shallowEqual);

    const userDetailString = singleApprovalDetails && (singleApprovalDetails?.entityApprovalDto?.entityApprovalAction?.entityApprovalDto?.detail)

useEffect(() => {
  if (props.showModal) {
    const userDetailString =
      singleApprovalDetails?.entityApprovalDto?.entityApprovalAction?.entityApprovalDto?.detail;

    if (userDetailString) {
      try {
        const parsedData = JSON.parse(userDetailString);
        if (JSON.stringify(parsedData) !== JSON.stringify(user)) {
          setUser(prev => ({
            ...prev,
            ...parsedData
          }));
        }
      } catch (err) {
        console.error("Invalid JSON:", err);
      }
    }
  }
}, [singleApprovalDetails, props.showModal]);
 
    let userData;
    if (props.setSelectedApprovalUser) {
        userData = props.setSelectedApprovalUser;
    }
    useEffect(() => {
        if (userData && userData.userOasApprovalDeptRole) {
            setDeparmentList(userData && userData.userOasApprovalDeptRole.department.id)
            setRoleList(userData && userData.userOasApprovalDeptRole.role.id)
            setSupervisorList(userData && userData.userOasApprovalDeptRole.supervisor.id)
        }
    }, [userData && userData.userOasApprovalDeptRole])

    useEffect(() => {
        dispatch(getAllRoles(departmentList))
    }, [departmentList])

    useEffect(() => {
        if (departmentList && roleList) {
            dispatch(getSupervisorByDeptAndRoleId(departmentList, roleList))
        }
    }, [departmentList, roleList])
  
    const handleChangeDepartment = (evt) => {
        setDeparmentList(evt.target.value || user.departmentId)
        getRoleByDept()
    }

    const handleChangeRole = (e) => {
        setRoleList(e.target.value || user.roleId )
        getSupervisor()
    }

    const handleChangeSupervisor = (e) => {
        setSupervisorList(e.target.value)
    }

    const getRoleByDept = () => {
        dispatch(getAllRoles())
    }

    const getSupervisor = () => {
        let deptId = watch("departmentList");
        let roleId = watch("roleList");
        dispatch(getSupervisorByDeptAndRoleId(deptId, roleId))
    }

      useEffect(()=>{
          if(userDetailString){
              setDeparmentList(userDetailString.departmentId)
              setRoleList(userDetailString.roleId)
              setSupervisorList(userDetailString.supervisorId)  
        }
    },[singleApprovalDetails])

    const onSubmit = (data,singleApprovalDetails) => {
     const {firstName,lastName,email,mobile,password,roleList,departmentList,comment,supervisorList,username}  = data;

     const updateUserDetail = {
          email,
          mobile,
          roleId: roleList,
          isActive: true,
          lastName,
          password:userDetailString.password,
          roleName: "",
          username: userDetailString.username,
          firstName,
           departmentId : departmentList,
          departmentName: "",
          supervisorName: "",
          supervisorId: supervisorList,
     }        
     singleApprovalDetails.entityApprovalDto.entityApprovalAction.entityApprovalDto.detail = JSON.stringify(updateUserDetail)
     singleApprovalDetails.entityApprovalDto.entityApprovalAction.comment = comment;
     dispatch(editAllApprovalUser(singleApprovalDetails))
             props.setShowModal(false)

    }
    
    return (
        <Modal size="xl" show={props.showModal} onHide={() => { props.setShowModal(false) }} aria-labelledby="example-modal-sizes-title-xl" backdrop='static'>
            <form >
                <Modal.Header className="logout_heading">
                    <Modal.Title className="logout_title">
                        {props.header}
                    </Modal.Title>
                      <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                      onClick={() => { props.setShowModal(false) }}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                    <div className="row" >
                        <div className="col-md-8">
                            <div className="row">
                                <div className="form-group col-md-6 mb-0">
                                    <label className="LeftText">{userLabels.FIRST_NAME} <span className="redColor">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="firstName"
                                        defaultValue={ user.firstName}
                                        ref={register({
                                            required: true, pattern: {
                                                value: /^[A-Za-z_.]+$/i
                                            }, maxLength: 30
                                        })}
                                    />
                                    {_.get("firstName.type", errors) === "required" && (
                                        <p className="errorText">{userLabels.MANDATORY_FIELD_MESSAGE}</p>
                                    )}
                                    {_.get("firstName.type", errors) === "pattern" && (
                                        <p className="errorText">{userLabels.ENTER_VALID_FIRSTNAME}</p>
                                    )}
                                    {_.get("firstName.type", errors) === "maxLength" && (
                                        <p className="errorText">{userLabels.MAX_VALUE_FOR_30_CHAR}</p>
                                    )}

                                </div>
                                <div className="form-group col-md-6 mb-0">
                                    <label className="LeftText">{userLabels.LAST_NAME}<span className="redColor">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="lastName"
                                        defaultValue={userData && userData.userOasApproval && userData.userOasApproval.lastName || user.lastName}
                                        ref={register({
                                            required: true, pattern: {
                                                value: /^[A-Za-z_.]+$/i
                                            }, maxLength: 30
                                        })}
                                    />
                                    {_.get("lastName.type", errors) === "required" && (
                                        <p className="errorText">{userLabels.MANDATORY_FIELD_MESSAGE}</p>
                                    )}
                                    {_.get("lastName.type", errors) === "pattern" && (
                                        <p className="errorText">{userLabels.ENTER_VALID_LASTNAME}</p>
                                    )}
                                    {_.get("lastName.type", errors) === "maxLength" && (
                                        <p className="errorText">{userLabels.MAX_VALUE_FOR_30_CHAR}</p>
                                    )}
                                </div>
                                <div className="form-group col-md-6 mb-0">
                                    <label className="LeftText">{userLabels.EMAIL_ID}<span className="redColor">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="email"
                                        defaultValue={userData && userData.userOasApproval && userData.userOasApproval.email || user.email }
                                        ref={register({ required: true, pattern: emailRegex })}
                                    />
                                    {_.get("email.type", errors) === "required" && (
                                        <p className="errorText">{userLabels.MANDATORY_FIELD_MESSAGE}</p>
                                    )}
                                    {_.get("email.type", errors) === "pattern" && (
                                        <p className="errorText">{userLabels.ENTER_VALID_EMAIL}</p>
                                    )}
                                </div>
                                <div className="form-group col-md-6 mb-0">
                                    <label className="LeftText">{userLabels.MOBILE_NUMBER}<span className="redColor">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="mobile"
                                        defaultValue={userData && userData.userOasApproval && userData.userOasApproval.mobile || user.mobile}
                                        maxLength={10}
                                        ref={register({
                                            required: true,
                                            pattern: {
                                                value: /^\s*([1-9]{1}[0-9]{9})\s*$/
                                            }
                                        })}
                                    />
                                    {_.get("mobile.type", errors) === "required" && (
                                        <p className="errorText">{userLabels.MOBILE_REQ}</p>
                                    )}
                                    {_.get("mobile.type", errors) === "pattern" && (
                                        <p className="errorText">{userLabels.MOBILE_PATTERN}</p>
                                    )}
                                </div>
                            </div>
                            <div style={{ height: "200px", overflowY: "auto", overflowX: "hidden" }}>
                                <div className="card" style={{ marginTop: "30px" }}>
                                    <div className="card-header" style={{ height: "40px", paddingTop: "0px" }}>
                                        <div className="row" style={{ paddingTop: "0px" }}>
                                            <div className="form-group col-md-4 mb-0">
                                                <label className="LeftText">Department<span className="redColor">*</span>
                                                </label>
                                            </div>
                                            <div className="form-group col-md-4 mb-0">
                                                <label className="LeftText">Role<span className="redColor">*</span>
                                                </label>
                                            </div>
                                            <div className="form-group col-md-4 mb-0">
                                                <label className="LeftText">Supervisor<span className="redColor">*</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body" style={{ paddingTop: "0.5rem" }}>
                                        <div className="row" style={{ marginTop: "1rem" }}>
                                            <div className="form-group col-md-4 mb-0">
                                                <select className="form-control" name="departmentList" value={departmentList || user.departmentId } onInput={handleChangeDepartment} ref={register({ required: true })}>
                                                    <option key="" value="">Select</option>
                                                    {adminDepartments && adminDepartments.map((ele, i) => {
                                                        return <option key={i} value={ele.id}>{ele.name}</option>
                                                    })}
                                                </select>
                                            </div>
                                            <div className="form-group col-md-4 mb-0">
                                                <select className="form-control" name="roleList" value={roleList || user.roleId } disabled={!departmentList} onInput={handleChangeRole} ref={register({ required: true })}>
                                                    <option key="" value="">Select</option>
                                                    {roleByDept && roleByDept.map((ele, index) =>
                                                        <option key={index} value={ele.id}>{ele.name}</option>
                                                    )}
                                                </select>
                                            </div>
                                            <div className="form-group col-md-3 mb-0">
                                                <select className="form-control" name="supervisorList" disabled={!(departmentList && roleList)} value={supervisorList} onInput={handleChangeSupervisor} ref={register({ required: true })}>
                                                    <option key="" value="">Select</option>
                                                    {supervisorByRole && supervisorByRole.map((ele, iindex) => {
                                                        return <option key={iindex} value={ele.id}>{ele.username}</option>
                                                    })}
                                                </select>
                                            </div>
                                            {/* </div> */}
                                            {/* <div className="form-group col-md-1 mb-0">
                                    <i style={{fontSize:"15px", color:"red"}} className='fa fa-trash' aria-hidden="true" onClick={()=> {deleteItem(index)}}></i>
                                    </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <button type="button" className=" btn btn-primary custom_button  btn-sm" style={{marginTop:"5px"}} onClick={handleAssignAnother}>Assign Another</button> */}
                        </div>
                        <div className="col-md-4">
                            <div className="card">
                                <div className="card-header">
                                    Approval Level
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <label style={{ fontWeight: 'bold' }}>Action</label>
                                        </div>
                                        <div className="col-md-9">
                                            <span>{userData && userData.userOasApproval && userData.userOasApproval.approvalType}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <label style={{ fontWeight: 'bold' }}>Status</label>
                                        </div>
                                        <div className="col-md-9">
                                            <span>{userData && userData.userOasApproval && userData.userOasApproval.status}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <label style={{ fontWeight: 'bold' }}>Approval</label>
                                        </div>
                                        <div className="col-md-9">
                                            <span>{userData && userData.lastApprover}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <label style={{ fontWeight: 'bold' }}>Comments</label>
                                        </div>
                                        <div className="col-md-9 word-break">
                                            <span>{userData && userData.lastApproverComments}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="form-group mt-3">
                                <h6 style={{ fontWeight: 'bold' }}>Comments<span className="redColor">*</span></h6>
                                <h6 >
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="comment"
                                        maxLength={255}
                                        placeholder={docLabels.ENTER_TEXT_UPTO_255_CHARACTERS}
                                        ref={register({ required: true })}
                                    /></h6>
                            </div>
                        </div>
                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" type="button" onClick={() => { props.setShowModal(false) }}>Cancel</button>
                    <button className=" btn btn-primary custom_button   " type="submit" onClick={handleSubmit((e) => { onSubmit(e,singleApprovalDetails) })}>Save</button>
                </Modal.Footer>
            </form>
        </Modal>
    )
}

export default UpdateApprovalUser